/* Fill gaps in Shopify Inbox's native chat-shell translations. */
(() => {
  'use strict';
  const dictionaries = {
    fr: {
      'Start a new chat?': 'Démarrer une nouvelle conversation ?',
      'Sign in to save your chat history, or continue without signing in.': 'Connectez-vous pour enregistrer l’historique de vos conversations, ou continuez sans vous connecter.',
      'Continue without signing in': 'Continuer sans se connecter',
      'Sign in': 'Se connecter', 'Profile': 'Profil', 'Sign out': 'Se déconnecter',
      'Back to chat': 'Retour au chat', 'Create a new chat': 'Créer une nouvelle conversation'
    },
    ja: {
      'Start a new chat?': '新しいチャットを始めますか？',
      'Sign in to save your chat history, or continue without signing in.': 'ログインするとチャット履歴を保存できます。ログインせずに続けることもできます。',
      'Continue without signing in': 'ログインせずに続ける',
      'Sign in': 'ログイン', 'Profile': 'プロフィール', 'Sign out': 'ログアウト',
      'Back to chat': 'チャットに戻る', 'Create a new chat': '新しいチャットを作成'
    },
    de: {
      'Start a new chat?': 'Einen neuen Chat starten?',
      'Sign in to save your chat history, or continue without signing in.': 'Melde dich an, um deinen Chatverlauf zu speichern, oder fahre ohne Anmeldung fort.',
      'Continue without signing in': 'Ohne Anmeldung fortfahren',
      'Sign in': 'Anmelden', 'Profile': 'Profil', 'Sign out': 'Abmelden',
      'Back to chat': 'Zurück zum Chat', 'Create a new chat': 'Neuen Chat starten'
    },
    es: {
      'Start a new chat?': '¿Quieres iniciar un nuevo chat?',
      'Sign in to save your chat history, or continue without signing in.': 'Inicia sesión para guardar tu historial de chat o continúa sin iniciar sesión.',
      'Continue without signing in': 'Continuar sin iniciar sesión',
      'Sign in': 'Iniciar sesión', 'Profile': 'Perfil', 'Sign out': 'Cerrar sesión',
      'Back to chat': 'Volver al chat', 'Create a new chat': 'Iniciar un nuevo chat'
    },
    it: {
      'Start a new chat?': 'Vuoi iniziare una nuova chat?',
      'Sign in to save your chat history, or continue without signing in.': 'Accedi per salvare la cronologia delle chat oppure continua senza accedere.',
      'Continue without signing in': 'Continua senza accedere',
      'Sign in': 'Accedi', 'Profile': 'Profilo', 'Sign out': 'Esci',
      'Back to chat': 'Torna alla chat', 'Create a new chat': 'Inizia una nuova chat'
    }
  };
  const translations = dictionaries[document.documentElement.lang.toLowerCase().split('-')[0]];
  if (!translations) return;
  const shells = new WeakSet(), runtimes = new WeakSet();
  function translate(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const source = node.nodeValue.trim();
      if (Object.prototype.hasOwnProperty.call(translations, source)) {
        node.nodeValue = node.nodeValue.replace(source, translations[source]);
      }
    }
    root.querySelectorAll('[aria-label], [label], [title]').forEach(element => {
      ['aria-label', 'label', 'title'].forEach(attribute => {
        const source = element.getAttribute(attribute);
        if (Object.prototype.hasOwnProperty.call(translations, source)) {
          element.setAttribute(attribute, translations[source]);
        }
      });
    });
  }
  function connect() {
    const shell = document.querySelector('shopify-chat')?.shadowRoot;
    if (!shell) return false;
    if (!shells.has(shell)) {
      shells.add(shell);
      new MutationObserver(connect).observe(shell, {childList:true, subtree:true});
    }
    const root = shell.querySelector('shopify-agent-runtime')?.shadowRoot;
    if (!root) return false;
    if (!runtimes.has(root)) {
      runtimes.add(root);
      translate(root);
      new MutationObserver(() => translate(root)).observe(root, {
        childList:true, subtree:true, characterData:true,
        attributes:true, attributeFilter:['label', 'aria-label', 'title']
      });
    }
    return true;
  }
  if (connect()) return;
  let attempts = 0;
  const timer = setInterval(() => {
    if (connect() || ++attempts >= 120) clearInterval(timer);
  }, 250);
})();
